"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const react_router_dom_1 = require("react-router-dom");
/**
 * A custom hook to query the current url
 */
const useQuery = () => {
    return new URLSearchParams((0, react_router_dom_1.useLocation)().search);
};
exports.useQuery = useQuery;
